import type { BasicCustomMailOptionalItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductPlanFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	atCheckOutAfter_01days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckOutAfter_01daysForText: (value: string) => void;
	onSetAtCheckOutAfter_01daysForOverride: (value: boolean) => void;
	onSetAtCheckOutAfter_01daysForShouldSendMail: (value: boolean) => void;
	hotelEmailAddress: string;

	lang: LangCode;

	handleClickedSendTestEmailReservationAtCheckOutAfter_01days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;

	title?: string;
	guide?: string;

	/** 基本メール設定 */
	basicCustomMailSetting: ProductPlanFormModel["QueryData"]["basicCustomMailSetting"];
};

export const ForCheckOutEmailTemplates = ({
	isEdited,
	hasError,
	atCheckOutAfter_01days,
	onSetAtCheckOutAfter_01daysForText,
	onSetAtCheckOutAfter_01daysForOverride,
	onSetAtCheckOutAfter_01daysForShouldSendMail,
	hotelEmailAddress,
	lang,
	handleClickedSendTestEmailReservationAtCheckOutAfter_01days,

	title: _title,
	guide: _guide,
	basicCustomMailSetting,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"翌日"}
						dialogTitle={"チェックアウト翌日"}
						textValue={atCheckOutAfter_01days?.text.value}
						isOverride={atCheckOutAfter_01days?.override.value}
						shouldSendEmail={atCheckOutAfter_01days?.shouldSendEmail.value}
						textErrorMessage={atCheckOutAfter_01days?.text.error}
						overrideErrorMessage={atCheckOutAfter_01days?.override.error}
						shouldSendEmailErrorMessage={atCheckOutAfter_01days?.shouldSendEmail.error}
						handleChangeText={onSetAtCheckOutAfter_01daysForText}
						handleChangeOverride={onSetAtCheckOutAfter_01daysForOverride}
						handleChangeShouldSendEmail={onSetAtCheckOutAfter_01daysForShouldSendMail}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckOutAfter_01days}
						hotelEmailAddress={hotelEmailAddress}
						overrideMode={atCheckOutAfter_01days?.override.value}
						onOverrideModeChange={onSetAtCheckOutAfter_01daysForOverride}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckOutAfter_01days}
					/>
				</div>
			}
		/>
	);
};

ForCheckOutEmailTemplates.displayName = "ForCheckOutEmailTemplates";
